var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 2.66661C9.50989 2.69428 8.65863 3.03951 8.0004 3.63994C7.34217 3.03951 6.49091 2.69428 5.6004 2.66661C5.12438 2.663 4.65244 2.75454 4.21229 2.93586C3.77214 3.11717 3.37266 3.3846 3.0373 3.72245C2.70194 4.06029 2.43746 4.46174 2.2594 4.90322C2.08134 5.34469 1.99328 5.81729 2.0004 6.29327C2.0004 8.53994 3.75373 10.5799 6.77373 13.3333L7.1004 13.6333C7.34619 13.8581 7.66726 13.9829 8.0004 13.9829C8.33354 13.9829 8.65461 13.8581 8.9004 13.6333L9.22707 13.3399C12.2471 10.5733 14.0004 8.53327 14.0004 6.29327C14.0075 5.81729 13.9195 5.34469 13.7414 4.90322C13.5633 4.46174 13.2989 4.06029 12.9635 3.72245C12.6281 3.3846 12.2287 3.11717 11.7885 2.93586C11.3484 2.75454 10.8764 2.663 10.4004 2.66661Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearticon);
export default __webpack_public_path__ + "static/media/hearticon.99394678fe9f6bfd276c9b448291d5c0.svg";
export { ForwardRef as ReactComponent };